// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"141":"f8a414c9","462":"f8a414c9","578":"f8a414c9"}[chunkId] + ".chunk.css";
};